module.exports = __webpack_public_path__ + "img/login-bg.f742961c.jpg";